import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import ViewEmployee from "../view";
import ViewEmployeeSalary from "./view";
import EditEmployeeSalary from "./edit";
import { MODULE_SALARIES } from "variables/constants";

const employeeSalaryRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Employee Salaries",
		basePath: "employees/:employeeId/employee-salaries",
		mainComponent: <ViewEmployee />,
	    layout: "/console",	
	    subTitle:"Employee Salary",
	    viewComponent: <ViewEmployeeSalary />,
	    createComponent: <EditEmployeeSalary />,
	    editComponent: <EditEmployeeSalary />,
		level:3,
		moduleId: MODULE_SALARIES,
	})
]

export default employeeSalaryRoutes;